// actions/types.js
export const FETCH_WALLET_BALANCE = 'FETCH_WALLET_BALANCE';
export const FETCH_CMS_WALLET_BALANCE = 'FETCH_CMS_WALLET_BALANCE';
export const FETCH_CHARGEBACK_BALANCE = 'FETCH_CHARGEBACK_BALANCE';
export const FETCH_PARTNER_DATA = 'FETCH_PARTNER_DATA';
export const FETCH_ERROR = 'FETCH_ERROR';
export const SET_ERROR = 'SET_ERROR';
